<template lang="pug">
  v-dialog(v-model='dialogFacturaNotaCreditoDescuento' scrollable persistent max-width='60%')
    v-card
      v-card-text
        v-container(id="factura")
          table.tabla(border="0" align="center" height="700")
            tr.letra
              td.border-round(colspan='3' valign='top')
                table(border='0' width='100%' cellpadding='4')
                  tr(v-if='form.idPedido')
                    td(colspan='2')
                      label Razon Social: 
                      b.letra2 {{form.idPedido.idCliente.nombre}}
                    td(width='20%' align='right')
                      label  Fecha: 
                      b.letra2 {{form.fechaCreacion}}
                  tr(v-if='form.idPedido')
                    td(colspan='2')
                      label C.I. / RIF: 
                      b.letra2 {{form.idPedido.idCliente.rif}}
                    td(align='right')
                      label Telefono: 
                      b.letra2 {{form.idPedido.idCliente.telefono}}
                  tr(v-if='form.idPedido')
                    td(colspan='2')
                      label Nombre y Apellido: 
                      b.letra2 {{form.idPedido.idCliente.nombre}}
                  tr(v-if='form.idPedido')
                    td(colspan='2')
                      label Direccion: 
                      b.letra2 {{form.idPedido.idCliente.direccion}}
                  tr(v-if='form.idPedido')
                    td(width='30%')
                      label Ciudad: 
                      b.letra2 {{form.idPedido.idCliente.ciudad}}
                    td(width='30%' v-if='form.idPedido.idCliente')
                      label Estado: 
                      b.letra2 {{form.idPedido.idCliente.codEstado.nombre}}
            br
            tr
              td(align='left')
                b.letra3 NOTA DE CRÉDITO: 
                b.rojo {{form.numNotaCredito}}
            tr
              td(colspan='3' valign='top')
                table.tabla2(border='0' width='100%' cellpadding='4')
                  tr(style="background-color:#E8E2E2;")
                    td(align="left")
                      div
                        span.letra5 Fecha
                    td(align="left")
                      div
                        span.letra5 Referencia
                    td(align="left")
                      div
                        span.letra5 Afectado
                    td(align="left")
                      div
                        span.letra5 Concepto
                    td.mar
                      div
                        span 
                    td
                      div
                        span 
                    td
                      div
                        span 
                    td(align="right")
                      div
                        span.letra5 Monto
                  tr
                    td(align='left') {{form.fechaCreacion}}
                    td(align='left') {{form.numNotaCredito}}
                    td(align='left') {{form.numFactura}}
                    td(align='left') Nota de Crédito Cliente
                    td(align='left') 
                    td(align='left')
                    td(align='left')
                    td(align='right') {{form.total}}
            div(style="margin-top: 25px")
            tr
              td(colspan='3' valign='top')
                table(border='0' width='100%' cellpadding='4')
                  tr
                    td(colspan='3')
                      table(width='100%' cellpadding='4') 
                        td(width='25%')
                        td(width='40%')
                        td(align='right')
                          label Exento:
                          br
                          label Base Imponible:
                          br
                          label Monto IVA:
                          br
                          label Descuento 
                          b.letra2 {{form.descuento}}%:
                          br
                          label SubTotal:
                          br
                          label Total:
                        td(align='right')
                          b.letra2 {{form.exento}}
                          br
                          b.letra2 {{form.baseImponible}} 
                          br
                          b.letra2 {{form.gravado}}
                          br
                          b.letra2 {{descuento}} 
                          br
                          b.letra2 {{form.subTotal}} 
                          br
                          b.letra2 {{form.total}}
                  tr(colspan='3' v-if="form.idPedido")
                    td
                      label Usuario:
                      b.letra2 {{form.idPedido.idUsuario.nombre}}
      v-card-actions
        v-spacer
        //v-btn(color='error' small dark @click='closeF')
          v-icon mdi-close
          | Cancelar
        v-btn(color='success' small dark @click="imprimirPDF()")
          v-icon mdi-content-save
          | Imprimir     
</template>

<script>
import printJS from 'print-js'
import { EventBus } from '../../Events'
import { formatoDecimal } from '@/helpers/index'

export default {
  name: 'Factura',
  props: ['dialogFacturaNotaCreditoDescuento', 'origen'],
  data: () => ({
    tasa: 0,
    totalDolares: 0,
    imagen: '',
    descuento: 0,
    form: {}
  }),

  watch: {},

  created () {
    EventBus.$on('dataFacturaNotaCreditoDescuento', data => {
      //console.log('DATA DESCUENTO', data)
      this.form = data
      this.descuento = (parseFloat(this.form.baseImponible) + parseFloat(this.form.exento)) * (this.form.descuento / 100)
      this.form.baseImponible = formatoDecimal(this.form.baseImponible)
      this.form.subTotal = formatoDecimal(this.form.subTotal)
      this.form.exento = formatoDecimal(this.form.exento)
      this.form.gravado = formatoDecimal(this.form.gravado)
      this.form.total = formatoDecimal(this.form.total)
      this.descuento = formatoDecimal(this.descuento)
      this.tasa = this.$store.state.config.tasa.tasaDia.valor
      this.imagen = 'data:image/png;base64,' + this.$store.state.logo64
    })
  },

  methods: {
    imprimirPDF () {
      printJS({
        printable: 'factura',
        type: 'html',
        targetStyles: ['*'],
        maxWidth: '100%',
        documentTitle: 'Nota Credito'
      })
      this.closeF2()
    },

    closeF2 () {
      this.$emit('close')

    },

  }
}
</script>

<style lang="scss">
  #factura {
    .rojo {
      color: red;
    }

    .letra {
      font-size: 12px;
    }

    .letra2 {
      font-size: 14px;
    }

    .letra3 {
      font-size: 15px;
      color: black;
    }

    .letra4 {
      font-size: 13px;
      color: black;
    }

    .letra5 {
      font-size: 14px;
      color: black;
      font-weight: bold;
    }

    .mar {
      padding: 10px 45px
    }

    .border-round {
      border: 1px solid grey;
      border-radius: 5px;
    }

    .right {
      float: right;
    }

    .right2 {
      float: right;
      font-size: 14px;
    }

    .tabla2 {
      border-collapse: collapse;
    }

    .tabla {
      width: 14pc x 21,6px  ; 
      position: center;
    }
  }
</style>
